import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
	AlumnoData,
	Button,
	CredencialCard,
	CredentialsContainer,
} from '../../assets/styled';
import { AlumnosContext } from '../../context/alumnos/AlumnosContext';
import { arrayMeses } from '../../utilities/utils';
import MainLogo from '../MainLogo';

export default function Credencial() {
	const alumnoCtx = useContext(AlumnosContext);
	const { getCredencial, credencialAlumno } = alumnoCtx;
	const dni = useParams().dni;
	const currentYear = new Date().getFullYear();
	const [añoSeleccionado, setAñoSeleccionado] = useState(currentYear);

	const navigate = useNavigate();

	const Header = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
				<AlumnoData>{`Alumno: ${credencialAlumno.nombre} ${credencialAlumno.apellido}`}</AlumnoData>
				<AlumnoData>{`Categoria ${credencialAlumno.categoria}`}</AlumnoData>
				<AlumnoData>Año: {currentYear}</AlumnoData>
			</div>
		);
	};
	const MonthCard = ({ month, index }) => {
		// Filtrar pagos por mes y año seleccionado, con compatibilidad para formatos legacy
		let result = credencialAlumno.pagos.filter((e) => {
			// Obtener mes del pago (nuevo formato, legacy intermedio, o legacy más antiguo)
			const mesPago = e?.mes || e?.mesPago2025 || e?.mesPago;
			
			// Obtener año del pago
			let añoPago = e?.año;
			if (!añoPago) {
				if (e?.mesPago2025) {
					// Formato legacy intermedio: asumir año 2025
					añoPago = 2025;
				} else if (e?.mesPago) {
					// Formato legacy más antiguo: extraer año de la fecha o asumir 2024
					if (e?.fecha) {
						const fechaParts = e.fecha.split('/');
						if (fechaParts.length === 3) {
							const añoDeFecha = parseInt(fechaParts[2]);
							if (!isNaN(añoDeFecha)) {
								añoPago = añoDeFecha;
							} else {
								// Si no se puede extraer, asumir año 2024
								añoPago = 2024;
							}
						} else {
							// Si la fecha no tiene formato válido, asumir año 2024
							añoPago = 2024;
						}
					} else {
						// Si no hay fecha, asumir año 2024
						añoPago = 2024;
					}
				}
			}
			
			return (
				arrayMeses.indexOf(mesPago?.toUpperCase()) === index &&
				añoPago === añoSeleccionado
			);
		});
		
		return (
			<CredencialCard>
				<div>{month}</div>
				<div>{result[0] ? result[0].fecha : ''}</div>
				<div>{result[0] ? `$${result[0].monto}` : ''}</div>
			</CredencialCard>
		);
	};

	useEffect(() => {
		if (dni) {
			getCredencial(dni);
		}
	}, [dni, getCredencial]);
	return (
		<div className='flexContainer'>
			<CredentialsContainer>
				<MainLogo />
				<Button onClick={() => navigate(-1)}>Volver</Button>
				{credencialAlumno && (
					<>
						<Header />
						<div style={{ marginBottom: '15px', textAlign: 'center' }}>
							<label style={{ marginRight: '10px' }}>Año:</label>
							<select
								value={añoSeleccionado}
								onChange={(e) => setAñoSeleccionado(parseInt(e.target.value))}
								style={{
									padding: '5px 10px',
									borderRadius: '4px',
									border: '1px solid #ccc',
								}}
							>
								{Array.from({ length: 5 }, (_, i) => {
									const año = currentYear - 2 + i;
									return (
										<option key={año} value={año}>
											{año}
										</option>
									);
								})}
							</select>
						</div>
						{arrayMeses.map((e, i) => {
							return <MonthCard key={i} month={e} index={i} />;
						})}
					</>
				)}
			</CredentialsContainer>
		</div>
	);
}
